import { RefObject } from 'react';
import {
  CreatorBenchmarks,
  DefaultMediaPackType,
  IPdfImage,
  InstagramInsightType,
} from '~/types';

import { MediaPackNavBar } from '../NavBar';

interface Props {
  mediaPack: DefaultMediaPackType;
  creatorBenchmarks: CreatorBenchmarks;
  creatorInsights: InstagramInsightType;
  pdfImages: IPdfImage[];
  activeSection: number;
  isSharedView?: boolean;
  sectionsRefs: RefObject<HTMLElement>[];
}

export const HeaderSection: React.FC<Props> = ({
  creatorBenchmarks,
  creatorInsights,
  mediaPack,
  pdfImages,
  activeSection = 0,
  isSharedView,
  sectionsRefs,
}) => (
  <>
    <MediaPackNavBar
      creatorBenchmarks={creatorBenchmarks}
      creatorInsights={creatorInsights}
      mediaPack={mediaPack}
      pdfImages={pdfImages}
      activeSection={activeSection}
      isSharedView={isSharedView}
      sectionsRefs={sectionsRefs}
    />
  </>
);
